import type { AccelerationContentFields } from '../AccelerationForm.types'
import { detailItemsToHtmlStrings } from './detailRichItems'

/** Shape sent to GraphQL — details steps/rules as HTML strings only (no React keys). */
export type AccelerationContentFieldsApi = Omit<AccelerationContentFields, 'details'> & {
  details: {
    pageTitle: string
    pageDescription: string
    steps: string[]
    rules: string[]
  }
}

export const serializeAccelerationContentForApi = (
  content: AccelerationContentFields
): AccelerationContentFieldsApi => {
  const { imageUrl: _imageUrl, ...rest } = content

  return {
    ...rest,
    details: {
      pageTitle: content.details.pageTitle,
      pageDescription: content.details.pageDescription,
      steps: detailItemsToHtmlStrings(content.details.steps),
      rules: detailItemsToHtmlStrings(content.details.rules)
    }
  }
}
